/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Email_PreheaderInputs */

const he_notifications_email_preheader = /** @type {(inputs: Notifications_Email_PreheaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ירד המחיר של מוצר שאתם עוקבים אחריו`)
};

const en_notifications_email_preheader = /** @type {(inputs: Notifications_Email_PreheaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price dropped on an item you track`)
};

/**
* | output |
* | --- |
* | "Price dropped on an item you track" |
*
* @param {Notifications_Email_PreheaderInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_email_preheader = /** @type {((inputs?: Notifications_Email_PreheaderInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Email_PreheaderInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_email_preheader(inputs)
	return en_notifications_email_preheader(inputs)
});